"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableArrowDown = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.TableArrowDown = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { width: "17", height: "17", viewBox: "0 0 100 50" }),
    React.createElement("path", { d: "M50 50L5 0L95 0L50 50Z", fill: props.fill || common_styles_1.black, stroke: props.stroke || common_styles_1.black }))); };
//# sourceMappingURL=tablearrowdown.js.map